<template>
  <label
    :class="[
      ns.b(),
      ns.is('disabled', disabled),
      ns.is('focus', focus),
      ns.is('icon', Boolean(icon || $slots.icon)),
      ns.is('checked', modelValue === value),
      ns.is('plain', plain),
      ns.m(size),
    ]"
    data-test-name="radio"
    data-test-variant=""
    data-test-state=""
  >
    <span
      :class="[
        ns.e('input'),
        ns.is('disabled', disabled),
        ns.is('checked', modelValue === value),
      ]"
    >
      <input
        ref="radioRef"
        v-model="modelValue"
        :class="ns.e('original')"
        :value="value"
        :name="name || radioGroup?.name"
        :disabled="disabled"
        type="radio"
        @focus="focus = true"
        @blur="focus = false"
        @change="handleChange"
      />
      <span :class="ns.e('inner')" />
    </span>
    <span
      :class="[
        ns.e('label'),
        ns.is('has-sub', Boolean($slots.sub || sub)),
        ns.is('has-icon', Boolean($slots.icon || icon)),
      ]"
      @keydown.stop
    >
      <b-icon v-if="$slots.icon || icon" :size="40" :class="ns.e('icon')">
        <slot name="icon">
          <component :is="icon" />
        </slot>
      </b-icon>
      <slot>
        {{ label }}
      </slot>
      <span v-if="$slots.sub || sub" :class="ns.e('sub')">
        <slot name="sub">
          {{ sub }}
        </slot>
      </span>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { nextTick } from 'vue'
import { useNamespace } from '@bigin/hooks'
import BIcon from '@bigin/components/icon'
import { radioEmits, radioProps } from './radio'
import { useRadio } from './use-radio'

defineOptions({
  name: 'BRadio',
})

const props = defineProps(radioProps)
const emit = defineEmits(radioEmits)

const ns = useNamespace('radio')
const { radioRef, radioGroup, focus, size, disabled, modelValue } = useRadio(
  props,
  emit
)

function handleChange() {
  nextTick(() => emit('change', modelValue.value))
}
</script>
